module.exports = __webpack_public_path__ + "static/media/veritas-screenshot-7.93f60959.png";